export const percentageOff = (price, compareAtPrice) =>
  compareAtPrice
    ? Math.round((100 * (compareAtPrice - price)) / compareAtPrice)
    : 0
